import Node from "./Node";
import {property} from "../voidash";

const getValue = property("value");

export default class ObserveNode extends Node {
  constructor(graph, pred, fn) {
    super(graph, pred);
    this.fn = fn;
    this.init();
  }

  init() {
    this.startObserving();
  }

  update() {
    if (!this.active) return;
    if (!this.observing) return; // might happen if we are a new node, therefore we are in changed sources
    this.value = this.fn(this.pred.map(getValue));
  }
}
